/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component } from '@angular/core';
import { MiddlewareBrowseComponent } from './middleware-browse.component';

@Component({
  selector: 'middleware-browse-modal',
  templateUrl: './middleware-browse-modal.component.html',
  styleUrls: ['./middleware-browse-modal.component.less'],
  standalone: false,
})
export class MiddlewareBrowseModalComponent extends MiddlewareBrowseComponent {}
